import React, { Component } from 'react';
import { Spin, message } from 'antd';
import { getNamesByLanguage } from '../../constants';
import TableC from '../../../basicElement/TableC';
import EditableCell from '../../../basicElement/EditableCell';
import FooterButton from '../Components/FooterButton';
import compareFn from '../Components/compareFn';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

let names = {};

class ServerContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            prevData: [],
            loading: false,
            editable: false,
        };
    }

    componentDidMount() {
        const { language } = this.props;
        names = getNamesByLanguage('serverContent', language);
        this.setState({
            data: [
                {num: '1', responsible: '中心启动支持', colSpan: 2},
                {num: '1.1', responsible: '中心可行性调研', editable: true},
            ]
        });
    }

    getColumns = () => {
        const { mode } = this.props;
        const { data, prevData, editable } = this.state;
        const columns = [{
            title: names.num,
            dataIndex: 'num',
            key: 'num',
            width: 100,
        }, {
            title: names.responsible,
            dataIndex: 'responsible',
            key: 'responsible',
            render: (text, record) => {
                const obj = {
                    children: text,
                    props: {},
                };
                const { colSpan = 1 } = record;
                obj.props.colSpan = colSpan;
                return obj;
            }
        }, {
            title: names.hasResponsible,
            dataIndex: 'hasResponsible',
            key: 'hasResponsible',
            width: 200,
            render: (text, record, index) => {
                const { colSpan = 1 } = record;
                const obj = {
                    children: '',
                    props: {},
                };
                if (colSpan > 1) {
                    obj.props.colSpan = 0;
                } else {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'hasResponsible');
                    } else {
                        obj.children = (
                            <div className="inlineBlock">
                                <EditableCell
                                    type="Radio"
                                    editable={editable}
                                    value={text}
                                    config={{options: names.defaultOptions}}
                                    onChange={value => this.handleChange(value, index, 'hasResponsible')}
                                />
                            </div>
                        );
                    }
                }
                return obj;
            }
        }];
        return columns;
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        const target = data[index];
        target[key] = value;
        this.setState({ data: [...data] });
    }

    confirm = (shouldValidate) => {
        if (!shouldValidate) {
            this.props.changeStep(-1);
        } else {
            const { status } = this.props;
            status === 'add' && this.props.changeStep(1);
        }
    }

    toggleEditable = (editable) => {
        this.setState({ editable });
    }

    render() {
        const { status, height } = this.props;
        const { loading, editable, data } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="quotation-content paddingBottom10" style={{ height }}>
                    <h2 className="quotation-title">{names.title}</h2>
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                        className="quotation_serverContent"
                        rowClassName={() => 'serverContent_bg'}
                    />
                </div>
                <FooterButton
                    status={status}
                    editable={editable}
                    confirm={this.confirm}
                    toggleEditable={this.toggleEditable}
                />
            </Spin>
        );
    }
}

export default ServerContent;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/ServerContent/index.js